import copy from "copy-to-clipboard";
import QRCode from "react-qr-code";
import React, { MutableRefObject } from "react";

const ClipboardCopy = require("../../../assets/images/icons/clipboard-copy.svg");
const CheckCircle = require("../../../assets/images/icons/check-circle-small.svg");

interface MFACodeProps {
  otpKey: string;
  uri: string;
}

interface MFACodeState {
  copyMessage: "pending" | "active";
}

export default class MFACode extends React.Component<
  MFACodeProps,
  MFACodeState
> {
  intervalRef: MutableRefObject<ReturnType<typeof setInterval>>;

  constructor(props: MFACodeProps) {
    super(props);

    this.state = {
      copyMessage: "pending" as const,
    };

    this.intervalRef = React.createRef();
  }

  render(): JSX.Element {
    const { alt, src, text } = this.copyMessage;

    return (
      <div className="mfa-setup-qr mt-2">
        <div className="mfa-setup-qr__code">
          <QRCode size={122} viewBox="0 0 122 122" value={this.props.uri} />
        </div>

        <div className="mfa-setup-qr__manual">
          <p className="mfa-setup-qr__manual-label">Manual entry</p>
          <p className="mfa-setup-qr__manual-code">{this.formattedOtpKey}</p>
          <button
            className="mfa-setup-qr__manual-copy"
            type="button"
            onClick={this.handleClickCopy}
          >
            <img src={src} alt={alt} />
            {text}
          </button>
        </div>
      </div>
    );
  }

  handleClickCopy = (): void => {
    this.setState({ copyMessage: "active" });

    if (this.intervalRef.current) {
      clearInterval(this.intervalRef.current);
    }

    this.intervalRef.current = setInterval(() => {
      this.setState({ copyMessage: "pending" });
    }, 1500);

    copy(this.props.otpKey);
  };

  get formattedOtpKey(): string {
    const chunks = [];

    for (let i = 0; i < this.props.otpKey.length; i += 4) {
      chunks.push(this.props.otpKey.slice(i, i + 4));
    }

    return chunks.join(" ");
  }

  get copyMessage(): { alt: string; src: any; text: string } {
    if (this.state.copyMessage === "pending") {
      return {
        alt: "Copy to clipboard icon",
        src: ClipboardCopy,
        text: "Copy code",
      };
    }

    return {
      alt: "Checkmark in circle icon",
      src: CheckCircle,
      text: "Copied!",
    };
  }
}
